<template>
  <div class="download">
    <div class="container" v-if="links">
      <div class="main-banner">
        <div class="container">
          <span>
            <strong>Important:</strong> PTDefender v2 only works with
            ProfitTrailer v2.4.11 and later
          </span>
        </div>
      </div>
      <el-row :gutter="20">
        <el-col :md="8">
          <el-card>
            <img src="/images/macos.jpg" />
            <div class="meta">
              <span class="title">macOS</span>
              <span class="version">v{{ links.version }}</span>
              <hr />
              <a :href="links.macOS.dmg">.dmg</a>
              <a :href="links.macOS.app">.app</a>
            </div>
          </el-card>
        </el-col>
        <el-col :md="8">
          <el-card>
            <img src="/images/linux.jpg" />
            <div class="meta">
              <span class="title">Linux</span>
              <span class="version">v{{ links.version }}</span>
              <hr />
              <a :href="links.linux.deb">.deb</a>
              <a :href="links.linux.rpm">.rpm</a>
              <a :href="links.linux.appImage">.AppImage</a>
              <a :href="links.linux.snap">.snap</a>
            </div>
          </el-card>
        </el-col>
        <el-col :md="8">
          <el-card>
            <img src="/images/windows.jpg" />
            <div class="meta">
              <span class="title">Windows</span>
              <span class="version">v{{ links.version }}</span>
              <hr />
              <a :href="links.windows.exe">.exe</a>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <br /><br /><br /><br />
      <div class="main-banner">
        <div class="container">
          <span>
            <strong>Important:</strong> PTDefender v1 only works with
            ProfitTrailer v2.4.10 and earlier
          </span>
        </div>
      </div>
      <el-row :gutter="20">
        <el-col :md="8">
          <el-card>
            <img src="/images/macos.jpg" />
            <div class="meta">
              <span class="title">macOS</span>
              <span class="version">v1.18.0</span>
              <hr />
              <a :href="v1Link(links.macOS.dmg)">.dmg</a>
              <a :href="v1Link(links.macOS.app)">.app</a>
            </div>
          </el-card>
        </el-col>
        <el-col :md="8">
          <el-card>
            <img src="/images/linux.jpg" />
            <div class="meta">
              <span class="title">Linux</span>
              <span class="version">v1.18.0</span>
              <hr />
              <a :href="v1Link(links.linux.deb)">.deb</a>
              <a :href="v1Link(links.linux.rpm)">.rpm</a>
              <a :href="v1Link(links.linux.appImage)">.AppImage</a>
              <a :href="v1Link(links.linux.snap)">.snap</a>
            </div>
          </el-card>
        </el-col>
        <el-col :md="8">
          <el-card>
            <img src="/images/windows.jpg" />
            <div class="meta">
              <span class="title">Windows</span>
              <span class="version">v1.18.0</span>
              <hr />
              <a :href="v1Link(links.windows.exe)">.exe</a>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import api from "@/lib/api";

export default {
  name: "Download",
  data() {
    return {
      links: null
    };
  },
  methods: {
    v1Link(input) {
      return input.replace(new RegExp(this.links.version, "gi"), "1.18.0");
    }
  },
  async mounted() {
    this.links = await api.downloadLinks();
  }
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.download {
  padding: 160px 10px;

  .main-banner {
    padding: 15px 10px;
    background-color: $--color-primary;
    text-align: center;
    border-radius: 3px;
    margin: 10px auto;

    a {
      color: #fff;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }

    span {
      color: #fff;
      font-weight: 400;
      text-decoration: none;
    }
  }

  .el-card {
    margin-bottom: 8px;
    border: none;
    .el-card__body {
      padding: 0;
    }
    img {
      display: block;
      width: 100%;
    }
    .meta {
      padding: 16px;
      .title {
        font-weight: 500;
        font-size: 22px;
      }
      .version {
        font-size: 14px;
        float: right;
        transform: translate(0, 8px);
      }
      a {
        display: inline-block;
        text-decoration: none;
        color: #333;
        background-color: #f9f9f9;
        padding: 8px 12px;
        border-radius: 3px;
        margin-right: 8px;
      }
    }
  }
}
</style>
